import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { UserModel } from './user.model';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../models/base';

const LIST_ENDPOINT = '/users/me';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly http = inject(HttpClient);

  async loadData(): Promise<UserModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<UserModel>>(environment.apiUrl + LIST_ENDPOINT)
    );

    return response.data;
  }
}